import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import { TranslationKeyMap } from '../../scorecard.i18n';
import { SuperGroupFilter } from '../scorecard-trend-chart/scorecard-trend-chart.model';

@Component({
    selector: 'sc-supergroup-filter',
    templateUrl: './sc-supergroup-filter.component.html',
    host: {
        class: 'sc-supergroup-filter',
    },
})
export class ScSupergroupFilterComponent implements OnDestroy {
    @Input() superGroups: SuperGroupFilter[];
    @Output() superGroupsChange: EventEmitter<SuperGroupFilter[]>;

    /** @private */ _i18n = TranslationKeyMap;

    constructor() {
        this.superGroupsChange = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.superGroupsChange.complete();
    }

    /** @private */
    _onSelectionChange(supergroup: SuperGroupFilter): void {
        supergroup.isSelected = !supergroup.isSelected;
        const selected = this.superGroups.filter(
            (sg) => sg.isSelected === true,
        );
        if (selected.length === 1) {
            selected[0].canBeDeselected = false;
        } else {
            // eslint-disable-next-line no-return-assign
            this.superGroups.forEach((i) => (i.canBeDeselected = true));
        }
        this.superGroupsChange.emit(this.superGroups);
    }
}
